import React from "react";
import { useLocation } from "react-router-dom";
import NewsFeedSkeleton from "./ProductDashboard/NewsFeed/NewsFeedSkeleton";
import ChartSkeleton from "./ProductDashboard/Charts/ChartSkeleton";
import SidebarSkeleton from "./Common/SidebarSkeleton";
import FilterBarSkeleton from "./Common/FilterbarSkeleton";
import HomeSkeleton from "./Home/HomeSkeleton";
import { CoTraderPageSkeleton } from "./CoTrader/CoTraderSkeletons";
import { ProductDashboardPageSkeleton } from "./ProductDashboard/ProductDashboardSkeletons";

const HOME_PATHS = ["/", "/home"];
const COTRADER_PATHS = ["/co-trader"];
const PRODUCT_DASHBOARD_PATHS = ["/dashboard"];

const DashboardSkeleton = () => {
  const { pathname } = useLocation();
  const normalizedPath = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  const isHome = HOME_PATHS.includes(normalizedPath);
  const isCoTrader = COTRADER_PATHS.includes(normalizedPath);
  // Desktop only: mobile renders ProductDashboardMobile, not the desk.
  const isProductDashboard =
    PRODUCT_DASHBOARD_PATHS.includes(normalizedPath) && window.innerWidth >= 768;

  return (
    <div className="d-flex bg-custom" style={{ height: "100vh" }}>
      <div style={{ flexShrink: 0 }}>
        <SidebarSkeleton />
      </div>
      <div className="flex-grow-1" style={{ overflow: "auto", height: "100%" }}>
        {isHome ? (
          <HomeSkeleton />
        ) : isCoTrader ? (
          <CoTraderPageSkeleton />
        ) : isProductDashboard ? (
          <ProductDashboardPageSkeleton />
        ) : (
          <>
            <div className="flex" style={{ height: "8%" }}>
              <FilterBarSkeleton />
            </div>
            <div
              className="p-3 bg-white rounded-4 rounded-left"
              style={{ height: "92%" }}
            >
              <ChartSkeleton />
              <NewsFeedSkeleton />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DashboardSkeleton;
